var map = {
	"./bbc54yyk/logo_ico.svg": "a862",
	"./chaoxinxing/logo_ico.svg": "65d2",
	"./ecshopx/logo_ico.svg": "0687",
	"./onex/logo_ico.svg": "4c5c",
	"./yyk/logo_ico.svg": "b7e90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b71";